import { WarningIcon } from "components/ui/icons/Warning/WarningIcon"
import styles from "./FilePartiallySupported.module.scss"

const { filePartiallySupported, filePartiallySupportedContent } = styles

type Props = { text: string }

export const FilePartiallySupported = ({ text }: Props) => {
	return (
		<div className={filePartiallySupported}>
			<div className={filePartiallySupportedContent}>
				<WarningIcon />
				<p>{text}</p>
			</div>
		</div>
	)
}
